import React, { useContext, useEffect, useState, useRef } from 'react';
import CreateGetFetch from '../../ServerCalls/CreateGetFetch';
import { Grid } from "@mui/material"
import ReadOnlyTable from "../../Component/DataGrids/AGGrid/ReadOnlyTable";
import CacheManager from '../../Utils/CacheManage';
import AppContext from '../../Context/AppContext';
import AvifaunaSitesUpdate from '../../Component/FormContainers/AvifaunaSitesUpdate';

const LocalityPage = () => {
    // const { data } = useFetch("/getLocalityTable");

    const [data, setData] = useState({ "data": [], "headers": [] });
    const AvifaunaSitesFormRef = useRef(null);

    const getObject = CreateGetFetch();
    const cacheManager = new CacheManager();
    const appState = useContext(AppContext);

    const handleCacheCall = async () => {
        if (cacheManager.doesExists("localityMap")) {
            setData(cacheManager.getEntry("localityMap"))
        } else {
            let res = await getObject.caller("/getLocalityTable");
            let _data = await res.json();
            setData(_data);
            cacheManager.setEntry("localityMap", _data);
        }
    };

    const refreshLocalityData = async () => {
        cacheManager.removeEntry("localityMap");
        await handleCacheCall();
    };

    useEffect(() => {
        if (data.data.length === 0) {
            handleCacheCall();
        }
    }, [data])

    const handleCellDoubleClick = (param) => {
        let data = param.data;
        AvifaunaSitesFormRef.current.setFormValues(data["CODE"], data["LocationName"], data["AvifaunaSite"], data["AvifaunaLatitude"], data["AvifaunaLongitude"], data["AvifaunaState"])
    }

    return (
        <Grid container justifyContent="center" >

            <Grid item sm={12} md={12} lg={5} >
                <div style={{ boxSizing: "border-box", width: "100%", paddingInlineStart: "0.5rem", }}>
                    <div
                        className="ag-theme-quartz" 
                        style={{ height: 500 }} // the grid will fill the size of the parent container
                    >
                        <ReadOnlyTable
                            TableData={data}
                            config={{
                                onCellDoubleClicked: handleCellDoubleClick
                            }}
                        />
                    </div>
                </div>
            </Grid>

            {
                appState.getAuthStat() === "Admin" && (
                    <Grid item sm={12} md={12} lg={6}>
                        <AvifaunaSitesUpdate
                            ref={AvifaunaSitesFormRef}
                            onUpdateSuccess={refreshLocalityData}
                        />
                    </Grid>
                )
            }

        </Grid>
    )
}

export default LocalityPage